import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['iframe', 'indicator']

  connect() {
    this.boundOnIframeLoad = this.onIframeLoad.bind(this)
    this.iframeTarget.addEventListener('load', this.boundOnIframeLoad)

    this.boundResize = this.checkScrollability.bind(this)
    window.addEventListener('resize', this.boundResize)

    // Check if the iframe is already loaded
    if (this.iframeTarget.contentDocument && this.iframeTarget.contentDocument.readyState === 'complete') {
      this.onIframeLoad()
    }
  }

  disconnect() {
    this.iframeTarget.removeEventListener('load', this.boundOnIframeLoad)
    window.removeEventListener('resize', this.boundResize)
    if (this.iframeWindow) {
      this.iframeWindow.removeEventListener('scroll', this.boundOnScroll)
    }
  }

  onIframeLoad() {
    this.iframeWindow = this.iframeTarget.contentWindow
    if (!this.iframeWindow) return

    // Bind scroll handler
    this.boundOnScroll = this.onScroll.bind(this)
    this.iframeWindow.addEventListener('scroll', this.boundOnScroll)

    // Check scrollability and scroll position after a short delay to allow layout to settle
    setTimeout(() => {
      this.checkScrollability()
      this.onScroll()
    }, 150)
  }

  checkScrollability() {
    if (!this.iframeWindow || !this.iframeWindow.document) return
    const docEl = this.iframeWindow.document.documentElement
    
    // Check if the actual content height is greater than the viewport height plus a small buffer
    const scrollHeight = docEl.scrollHeight
    const clientHeight = docEl.clientHeight
    const isScrollable = scrollHeight > clientHeight + 10

    if (isScrollable) {
      this.indicatorTarget.classList.remove('is-not-scrollable')
    } else {
      this.indicatorTarget.classList.add('is-not-scrollable')
    }
  }

  onScroll() {
    if (!this.iframeWindow) return
    const scrollY = this.iframeWindow.scrollY || this.iframeWindow.pageYOffset || 0

    // Hide the pill indicator if the user has scrolled down
    if (scrollY > 10) {
      this.indicatorTarget.classList.add('is-scrolled')
    } else {
      this.indicatorTarget.classList.remove('is-scrolled')
    }
  }
}
